import { createContext } from "react";

const LoggerContext = createContext();

export default LoggerContext;
